import { observer } from "mobx-react";
import { playerStore } from "../../../store/player.store"

const PlayerSubmits = observer(() => {

  if (!playerStore.activeSubmits.length) return <></>

  return (
    <div className="submits-div">
      {
        playerStore.activeSubmits.map(item => (
            <div key={item} className="submit-text">{item}</div>
          )
        )}
    </div>
  );
});

export {
  PlayerSubmits
};
